import { filterConstants } from "../../../constants";
import {
  useBalances,
  useMerchantApiQuery,
  useMerchantApiQueryWithParams,
  useQueryString,
} from "../../../hooks";
import {
  IPageAndSearchRequest,
  IViewBalance,
  IViewBankAccount,
  IViewTransaction,
  PagedMeta,
} from "../../../interfaces-and-types";
import { IViewPayout } from "../../../interfaces-and-types/switchapp-api/payouts";
import { IPaymentQueryMeta } from "../../Payments/Payments";
import { View } from "./View";

interface IPayoutsByCurrency {
  currency: string | null;
}

export interface IBalanceTableViewProps {
  isLoadingBalances: boolean;
  balances: IViewBalance[];
  activeBalance: IViewBalance | null;
  setActiveBalanceCurrency: (currency: string) => void;
  isLoadingPayouts: boolean;
  payouts: IViewPayout[];
  isLoadingTopUps: boolean;
  topUps: IViewTransaction[];
}

export const BalanceTable = () => {
  const query = useQueryString();
  const startDate = query.get(filterConstants.startDateKey);
  const endDate = query.get(filterConstants.endDateKey);

  // const {
  //   isLoading: isLoadingBankAccounts,
  //   isSuccess: isSuccessBankAccounts,
  //   data: withdrawalBankAccounts,
  // } = useMerchantApiQueryWithParams<
  //   IPageAndSearchRequest,
  //   IViewBankAccount[],
  //   PagedMeta
  // >([
  //   "getBankAccounts",
  //   {
  //     page: 1,
  //     page_size: 5000,
  //     search: null,
  //   },
  // ]);

  // TODO: add a refresh button for manual update to the view
  const {
    activeBalanceCurrency,
    setActiveBalanceCurrency,
    isLoadingBalances,
    balances,
    refreshBalances,
  } = useBalances();

  const {
    isLoading: isLoadingPayouts,
    // isSuccess: isSuccessPayouts,
    data: payouts,
  } = useMerchantApiQueryWithParams<
    IPageAndSearchRequest & IPayoutsByCurrency,
    IViewPayout[],
    PagedMeta
  >([
    "getPayouts",
    {
      page: 1,
      page_size: 5,
      search: null,
      currency: activeBalanceCurrency,
    },
  ]);

  const {
    isLoading: isLoadingTopUps,
    // isSuccess: isSuccessTopUps,
    data: topUps,
  } = useMerchantApiQueryWithParams<
    IPageAndSearchRequest & IPaymentQueryMeta,
    IViewTransaction[],
    PagedMeta
  >([
    "getTopUps",
    {
      page: 1,
      page_size: 5,
      search: null,
      status: "successful",
      filter: {},
      start_date: startDate,
      end_date: endDate,
    },
  ]);

  const activeBalance = balances.find(
    (b) => b.currency === activeBalanceCurrency
  );

  return (
    <View
      isLoadingBalances={isLoadingBalances}
      balances={balances || []}
      activeBalance={activeBalance || null}
      setActiveBalanceCurrency={setActiveBalanceCurrency}
      isLoadingPayouts={isLoadingPayouts}
      payouts={payouts || []}
      isLoadingTopUps={isLoadingTopUps}
      topUps={topUps || []}
    />
  );
};
